import {
    colorCode,
    safetyPercentage,
    safetyProfile,
} from "../utilities/helpers"
import ShareSection from "./ShareSection"

export default function CardSafetyAnalysis({ place, currentLocation }) {
    return (
        <div className="card-body">
            <p className="card-text text-start">
                {place?.overall_safety_overview}
            </p>
            <div className="container text-center">
                <div className="row pt-2">
                    {/* Political Stability */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Stability
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.political_stability_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.political_stability_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.political_stability_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.political_stability_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.political_stability_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-peace pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.political_stability_score
                                        )
                                    )}`}
                                    title={`Political Stability: ${safetyProfile(
                                        safetyPercentage(
                                            place?.political_stability_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Anti-Crime */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Anti-Crime
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(place?.crime_score)
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(place?.crime_score)
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.crime_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.crime_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.crime_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-slash-circle pe-2 text-${colorCode(
                                        safetyPercentage(place?.crime_score)
                                    )}`}
                                    title={`Crime Prevention: ${safetyProfile(
                                        safetyPercentage(place?.crime_score)
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Cultural Sensitivity */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Cultural
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.cultural_sensitivity_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.cultural_sensitivity_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.cultural_sensitivity_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.cultural_sensitivity_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.cultural_sensitivity_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-person-raised-hand pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.cultural_sensitivity_score
                                        )
                                    )}`}
                                    title={`Cultural safety: ${safetyProfile(
                                        safetyPercentage(
                                            place?.cultural_sensitivity_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Air Quality */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Air Quality
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.air_quality_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.air_quality_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.air_quality_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.air_quality_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.air_quality_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-lungs pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.air_quality_score
                                        )
                                    )}`}
                                    title={`Air Quality: ${safetyProfile(
                                        safetyPercentage(
                                            place?.air_quality_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Medical Care */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Medical Care
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.medical_care_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.medical_care_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.medical_care_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.medical_care_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.medical_care_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-capsule pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.medical_care_score
                                        )
                                    )}`}
                                    title={`Medical Care: ${safetyProfile(
                                        safetyPercentage(
                                            place?.medical_care_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Transportation */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Transportation
                            </div>
                            <div className="col-md-9 col-10 progress-container">
                                <div className="d-md-none d-block"></div>{" "}
                                {/* spacer on mobile */}
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.transportation_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.transportation_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.transportation_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.transportation_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.transportation_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-car-front-fill pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.transportation_score
                                        )
                                    )}`}
                                    title={`Transportation safety: ${safetyProfile(
                                        safetyPercentage(
                                            place?.transportation_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Weather */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Weather
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(place?.weather_score)
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.weather_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.weather_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.weather_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.weather_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-umbrella pe-2 text-${colorCode(
                                        safetyPercentage(place?.weather_score)
                                    )}`}
                                    title={`Weather safety: ${safetyProfile(
                                        safetyPercentage(place?.weather_score)
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Environmental */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Environmental
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title={`${safetyProfile(
                                        safetyPercentage(
                                            place?.environmental_score
                                        )
                                    )}`}
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-${colorCode(
                                            safetyPercentage(
                                                place?.environmental_score
                                            )
                                        )}`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.environmental_score
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.environmental_score
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            {safetyPercentage(
                                                place?.environmental_score
                                            )}
                                            %
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-radioactive pe-2 text-${colorCode(
                                        safetyPercentage(
                                            place?.environmental_score
                                        )
                                    )}`}
                                    title={`Environmental safety: ${safetyProfile(
                                        safetyPercentage(
                                            place?.environmental_score
                                        )
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Personal Safety */}
                    <div className="container-fluid text-center px-0">
                        <div className="row g-2 pb-2 align-items-center">
                            <div className="col-md-2 col-12 small text-md-end text-start category-label">
                                Personal
                            </div>
                            <div className="col-md-9 col-10">
                                <div
                                    className="progress"
                                    title="See your dashboard for more details"
                                    style={{
                                        height: "20px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <div
                                        className={`progress-bar bg-secondary`}
                                        role="progressbar"
                                        aria-valuenow={safetyPercentage(
                                            place?.overall_safety
                                        )}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{
                                            width: `${safetyPercentage(
                                                place?.overall_safety
                                            )}%`,
                                        }}
                                    >
                                        <b>
                                            <i className="bi bi-question-circle"></i>
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 col-2">
                                <i
                                    className={`bi bi-person-bounding-box pe-2 text-secondary`}
                                    title={`Personal Safety: ${safetyProfile(
                                        safetyPercentage(place?.overall_safety)
                                    )}`}
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="text-muted" style={{ borderStyle: "dashed" }} />
            <ShareSection place={place} />
        </div>
    )
}
